"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationCategory = exports.MetricCategory = exports.ClientType = exports.MetricType = exports.MetricUnit = void 0;
var MetricUnit;
(function (MetricUnit) {
    MetricUnit["COUNT"] = "Count";
    MetricUnit["MILLISECONDS"] = "Milliseconds";
    MetricUnit["NONE"] = "None";
    MetricUnit["HOURS"] = "Hours";
})(MetricUnit = exports.MetricUnit || (exports.MetricUnit = {}));
var MetricType;
(function (MetricType) {
    MetricType["COUNT"] = "COUNT";
    MetricType["LATENCY"] = "LATENCY";
})(MetricType = exports.MetricType || (exports.MetricType = {}));
var ClientType;
(function (ClientType) {
    ClientType["WEB"] = "web";
    ClientType["MOBILE_WEB_VIEW"] = "mobileWebView";
    ClientType["MOBILE_NATIVE"] = "mobileNative";
})(ClientType = exports.ClientType || (exports.ClientType = {}));
var MetricCategory;
(function (MetricCategory) {
    MetricCategory["API_METRICS"] = "APIMetrics";
})(MetricCategory = exports.MetricCategory || (exports.MetricCategory = {}));
var DurationCategory;
(function (DurationCategory) {
    DurationCategory["REPORT_TRAVEL_TIME"] = "TravelTimeReportedDuration";
    DurationCategory["REPLACE_VTO_TO_PTO"] = "ReplaceVTOtoPTODuration";
})(DurationCategory = exports.DurationCategory || (exports.DurationCategory = {}));
